//'use strict';
niacs.directives = angular.module('NiacsProjectApp.directives', [
    'NiacsProjectApp.panes',
    'NiacsProjectApp.lms-services'
])
.directive('moreInfo',[function(){
  return {
    restrict: 'C',
    template: '<fa-icon icon="info-circle"></fa-icon>'
  };
}])
.directive('infoPanel',['CustomTextService',function(CustomTextService){
  return {
    restrict: 'E',
    template: '<span class="info-icon-wrapper">'+
    '<a ng-if="infoHtml" ng-click="toggle()" class="not-a-link {{color}}" href '+
    'uib-tooltip="Click for more information" tooltip-placement="auto right" tooltip-trigger="\'mouseenter\'" tooltip-append-to-body="true"'+
    'uib-popover-html="infoHtml" popover-trigger="\'outsideClick\'" popover-placement="auto {{placement}}" popover-append-to-body="true">'+
    '<fa-icon icon="info-circle"></fa-icon></a><span>  <edit-cust-text add-classes="not-a-link {{color}}" key="{{key}}"></edit-cust-text></span></span>',
    scope: {
      key: '@'
    },
    link: function($scope,$element,$attrs) {
        CustomTextService.html($scope.key).then(function(html) {
            $scope.infoHtml = html;
        });
        $scope.color = $attrs.iconColor ? $attrs.iconColor : 'white';
        $scope.placement = $attrs.placement ? $attrs.placement : 'bottom';
    }
  };
}])
.directive('infoIcon',['CustomTextService',function(CustomTextService){
  return {
    restrict: 'E',
    template: '<span class="info-icon-wrapper">'+
    '<a ng-if="html" class="not-a-link {{color}}" href '+
    'uib-tooltip-html="html" tooltip-placement="auto {{placement}}" tooltip-trigger="\'mouseenter\'" '+
    'tooltip-append-to-body="true"><fa-icon icon="info-circle"></fa-icon></a><span>  <edit-cust-text add-classes="not-a-link {{color}}" key="{{key}}"></edit-cust-text></span></span>',
    scope: {
      key: '@'
    },
    link: function($scope,$element,$attrs) {
        $scope.$watch('key',function(key){
            if(key) {
                CustomTextService.html(key).then(function(html){
                    $scope.html = html;
                });
            }
        });
      // top,left,right,bottom, css may be incomplete for other placements.
      $scope.placement = $attrs.placement ? $attrs.placement : 'right';
      $scope.color = $attrs.iconColor ? $attrs.iconColor : 'white';
    }
  };
}])
.controller('ResourcesDialogCtrl',['$scope','$uibModalInstance','title','resources',function($scope,$uibModalInstance,title,resources){
    $scope.title = title;
    $scope.resources = resources;
    $scope.dismiss = $uibModalInstance.dismiss;
}])
.factory('ResourcesService',['$q','$routeParams','$uibModal','$location','MenuService','NiacsResource','ProjectService','NiacsStrategyService',function($q,$routeParams,$uibModal,$location,MenuService,NiacsResource,ProjectService,NiacsStrategyService){
    var projectDef = $q.defer(),
        regionDef,
        stepsDefs = {},
        stepTitles = niacs.flattenMenu().reduce(function(map,item){
            if(item.item && item.label) {
                map[item.item] = item.label;
            }
            return map;
        },{}),
        service;
    ProjectService.get($routeParams,'ResourcesService',function(project){ projectDef.resolve(project); });
    function loadResources(context,deferred) {
        projectDef.promise.then(function(project){
            var params = niacs.getResourceFilter((context||project),project);
            if(params) {
                params.sort = '-sticky';
                NiacsResource.query(params,function(resources){
                    deferred.resolve((resources && resources.list) ? resources.list : []);
                });
            } else {
                deferred.resolve([]);
            }
        });
        return deferred.promise;
    }
    service = {
        stepKeys: function() {
            return Object.keys(niacs.menuSteps);
        },
        stepTitle: function(step) { // step optional, otherwise will figure out from UI state
            return stepTitles[step||MenuService.getMenuPath($location).getStep()];
        },
        regionalResources: function() {
            if(!regionDef) {
                return loadResources(undefined,(regionDef = $q.defer()));
            }
            return regionDef.promise;
        },
        stepResources: function(step) { // step optional, otherwise will figure out from UI state
            step = step||MenuService.getMenuPath($location).getStep();
            if(!stepsDefs[step]) {
                return loadResources(step,(stepsDefs[step] = $q.defer()));
            }
            return stepsDefs[step].promise;
        },
        strategyResources: function() {
            return projectDef.promise.then(function(project) {
                return NiacsStrategyService.getProjectSourceResources(project);
            });
        },
        openDialog: function(title,resources) {
            $uibModal.open({
                templateUrl: 'partials/dialogs/resources.html',
                controller: 'ResourcesDialogCtrl',
                windowClass: 'niacs-resources-dialog',
                resolve: {
                    title: function() { return title; },
                    resources: function() { return resources; }
                }
            });
        }
    };
    return service;
}])
.directive('niacsResources',['ResourcesService',function(ResourcesService){
  return {
    restrict: 'E',
    template: '<button ng-if="resources.length" id="{{id}}" class="btn btn-default niacs-btn-resource {{addClasses}}" ng-click="open()"><span>{{buttonText}}</span></button>',
    scope: {
      id: '@',
      addClasses: '@',
      context: '=' // 'step' or undefined for regional
    },
    link: function($scope,$element,$attrs) {
        $scope.buttonText = $scope.context === 'step' ? ResourcesService.stepTitle()+' Resources' : 'Regional Resources';
        ResourcesService[$scope.context === 'step' ? 'stepResources' : 'regionalResources']().then(function(resources) {
            $scope.resources = resources;
        });
        $scope.open = function() {
            ResourcesService.openDialog($scope.buttonText,$scope.resources);
        };
    }
  };
}])
.directive('niacsResourcesMenu',['$q','$window','$routeParams','ResourcesService','ProjectService',function($q,$window,$routeParams,ResourcesService,ProjectService){
    return {
        restrict: 'E',
        replace: true,
        template: '<li>'+
        '<div class="btn-group" uib-dropdown>'+
        '  <button id="resources-menu" type="button" class="btn niacs-btn-resource" uib-dropdown-toggle><fa-icon icon="bookmark"></fa-icon> Resources <span class="caret"></span></button>'+
        '  <ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="resources-menu">'+
        '    <li class="resources" ng-repeat="item in items" ng-if="item.resources.length" ng-click="open(item.title+\' Resources\',item.resources)">{{item.title}}</li>'+
        '    <li class="strategies-approaches" ng-repeat="resource in strategyResources" ng-click="strategies(resource)"><fa-icon icon="book"></fa-icon> {{resource.getSourceTitle()}} Adaptation Strategies and Approaches</li>'+
        '    <li ng-if="project && project.training && project.training.course && project.training.course_offering" ng-click="courseMaterials()">'+
        '      <fa-icon icon="graduation-cap"></fa-icon> View course materials'+
        '    </li>'+
        '  </ul>'+
        '</div>'+
        '</li>',
        scope: {},
        link: function($scope) {

            $scope.resourceCount = 0;
            $scope.open = ResourcesService.openDialog;
            $scope.strategies = function(resource) {
                $window.open('/niacs-strategies/'+resource.getSourceAlias(),'_blank');
            };
            $scope.courseMaterials = function() {
              var courseId = $scope.project.training.course,
                  offeringId = $scope.project.training.course_offering;
              $window.open('/niacs-course-materials#/'+courseId+'/'+offeringId,'niacs-course-materials');
            };
            $scope.items = [{
                index: 0,
                title: 'Regional',
            }].concat(ResourcesService.stepKeys().map(function(key,i){
                return {
                    index: (i+1),
                    context: key,
                    title: ResourcesService.stepTitle(key),
                };
            }));
            $q.all($scope.items.map(function(item){
                return ResourcesService[item.context ? 'stepResources' : 'regionalResources'](item.context);
            })).then(function(results) {
                results.forEach(function(result,i){
                    $scope.resourceCount += result.length;
                    $scope.items[i].resources = result;
                });
            });
            ProjectService.get($routeParams,'ResourcesMenu',function(project){ $scope.project = project;});
            ResourcesService.strategyResources().then(function(resources){
                $scope.strategyResources = resources;

            });
        }
    };
}])
.directive('editCustText',['UserProfileService','CustomTextService',function(UserProfileService,CustomTextService){
  return {
    restrict: 'E',
    template: '<a class="edit-cust {{addClasses}}" target="edit-cust-text" href="{{editLink}}" ng-if="up.isAdmin && editLink"><fa-icon icon="edit"></fa-icon></a>',
    scope: {
      key: '@',
      addClasses: '@'
    },
    link: function($scope,$element,$attrs) {
      UserProfileService.get(function(up){
        $scope.up = up;
      });
      $scope.$watch('key',function(key) {
          if(key) {
              CustomTextService.object(key).then(function(text){
                 if(text && text.id) {
                     $scope.editLink = '/node/'+text.id+'/edit';
                 }
              });
          }
      });
    }
  };
}])
.directive('niacsShowHide',function(){
    return {
      restrict: 'E',
      templateUrl: 'partials/directives/show-hide.html',
      scope: {
        $context: '=context'
      }
    };
})
.directive('projectDebug',['$document','$routeParams','ProjectService',function($document,$routeParams,ProjectService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/project-debug.html',
    scope: {
    },
    link: function($scope,$element,$attrs) {
      $scope.json = {privateData:false,prettyPrint:true};
      $scope.debug = {
        info: niacs.INFO,
        log: niacs.LOG,
        debug: niacs.DEBUG
      };
      function stringify(){
          if($scope.json.privateData) {
              if(!niacs.isEmpty($scope.json.fields)) {
                var fields = $scope.json.fields.split(','),
                    copy = angular.copy($scope.project);
                for(var key in copy) {
                  if(fields.indexOf(key) == -1) {
                    delete copy[key];
                  }
                }
                $scope.json.stringified = JSON.stringify(copy,null,$scope.json.prettyPrint?2:null);
              } else {
                $scope.json.stringified = JSON.stringify($scope.project,null,$scope.json.prettyPrint?2:null);
              }
          } else {
              $scope.json.stringified = angular.toJson($scope.project,$scope.json.prettyPrint);
          }
          if($scope.json.stringified) {
              $scope.json.sizeUnits = 'B';
              $scope.json.size = $scope.json.stringified.length;
              if($scope.json.stringified.length > 1024) {
                  $scope.json.sizeUnits = 'K';
                  $scope.json.size = ($scope.json.stringified.length/1024).toFixed(2);
              }
          }
      }
      $scope.stringify = stringify;
      $scope.$showDebug = false;
      // don't spend any cycles on debug until it has been 'turned on'.
      function startDebug(started) {
        if(started && !$scope.project) {
          niacs.info("debug panel loading project and starting watches.");
          $scope.$watch('json.fields',stringify);
          $scope.$watch('json.privateData',stringify);
          $scope.$watch('json.prettyPrint',stringify);
          $scope.$watch('debug.info',function(){niacs.INFO = $scope.debug.info; });
          $scope.$watch('debug.debug',function(){niacs.DEBUG = $scope.debug.debug; });
          $scope.$watch('debug.log',function(){niacs.LOG = $scope.debug.log; });
          ProjectService.get($routeParams,'projectDebug',function(p){
              $scope.project = p;
              $scope.$watch('project.$updateCount',stringify);
          });
        }
      }
      $document.bind('keypress', function(e) {
        if(e.ctrlKey && e.shiftKey && (e.charCode == 4 || e.key == "D" || e.key == "L") /*d*/) {
          $scope.$apply(function(){
            startDebug($scope.$showDebug = !$scope.$showDebug);
            $scope.debug.info = $scope.$showDebug; // turn on info logging by default.
          });
        }
      });
    }
  };
}])
.directive('vulnerabilitySliders',['$log','TaxonomyService','ProjectService',function($log,TaxonomyService,ProjectService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/vulnerability-sliders.html',
    scope: {
      target: '='
    },
    controller: function($scope) {
      TaxonomyService.get('niacs_vulnerability',function(data){
        $scope.vocab_vulnerability = data;
        $scope.slidersEnabled = true;
      });
      $scope.slidersEnabled = false;
      function set_dollar_value(key) {
        // if the value is set on the context then use it
        if(angular.isNumber($scope.target[key])) {
          $scope.target['$'+key] = $scope.target[key];
        } else if (!angular.isNumber($scope.target['$'+key])) { // if the server doesn't have a default set
          $scope.target['$'+key] = 50;
        }
        // else the server does have a default value, use it as the default.
        // to be safe make sure that the value is valid
        var valid_values = [0,25,50,75,100];
        if(valid_values.indexOf($scope.target['$'+key]) == -1) {
          $log.warn('WARNING: found invalid value for '+key+' '+$scope.target['$'+key]);
          $scope.target['$'+key] = 50;
          // make sure the project data isn't broken..
          if(typeof($scope.target[key]) !== undefined && valid_values.indexOf($scope.target[key]) === -1) {
            $log.warn('WARNING: corrupt project data found for '+key+' '+$scope.target[key]);
          }
        }
      }
      set_dollar_value('adaptive_capacity');
      set_dollar_value('potential_impacts');
      $scope.vulnerabilityNotDeterminded = typeof($scope.target.vulnerability) === 'undefined';
      $scope.initVulnerability = function(){
        $scope.target.adaptive_capacity = parseInt($scope.target.$adaptive_capacity);
        $scope.target.potential_impacts = parseInt($scope.target.$potential_impacts);
        set_vulnerability();
      };
      $scope.acOptions = {
          from: 0,
          to: 100,
          step: 25,
          scale: ["Low",'Low-Moderate','Moderate','Moderate-High','High'],
      };
      $scope.piOptions = {
          from: 0,
          to: 100,
          step: 25,
          scale: ["Very supportive",'Supportive','Mixed/Neutral','Disruptive','Very disruptive'],
      };
      function set_vulnerability(){
        var vidx = niacs.vulnerabilityIndex($scope.target.adaptive_capacity,$scope.target.potential_impacts);
        // assign the taxonomy id to the target's vulnerability, the taxonomy MUST be ordered L,M,H
        $scope.target.vulnerability = $scope.vocab_vulnerability[vidx].id;
        $scope.vulnerabilityNotDeterminded = false;
        $scope.slidersEnabled = false;
        ProjectService.save().then(function(p) {$scope.slidersEnabled = true;});
      }
      function check_update(key) {
        if(angular.isString($scope.target['$'+key])) { // ug, the slider does this but it gives an opportunity to save the change.
          $scope.target[key] = parseInt($scope.target['$'+key]);
          set_vulnerability();
        } else {
          set_dollar_value(key);
        }
      }
      $scope.$watch('target.$adaptive_capacity',function(){
        check_update('adaptive_capacity');
      });
      $scope.$watch('target.$potential_impacts',function(){
        check_update('potential_impacts');
      });
    }
  };
}])
.directive('vulnerabilitySlidersAg',['$log','TaxonomyService','ProjectService',function($log,TaxonomyService,ProjectService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/vulnerability-sliders-ag.html',
    scope: {
      target: '='
    },
    controller: function($scope) {
        $scope.slidersEnabled = false;
        TaxonomyService.get('niacs_vulnerability',function(data){
            if(typeof($scope.target.vulnerability) === 'undefined') {
                $scope.target.$vulnerability = data.length > 1 ? 1 : 0;
            } else {
                $scope.target.$vulnerability = data.map(function(d) { return d.id; }).indexOf($scope.target.vulnerability);
            }
            $scope.vocab_vulnerability = data;
            $scope.sliderOptions = {
                from: 0,
                to: (data.length-1),
                step: 1,
                scale: data.map(function(v) { return v.label; })
            };
            $scope.slidersEnabled = true;
        });
        $scope.vulnerabilityNotDeterminded = typeof($scope.target.vulnerability) === 'undefined';

        $scope.initVulnerability = function() {
            // translate the index to id.
            var idx = parseInt($scope.target.$vulnerability),
                new_id = $scope.vocab_vulnerability[idx].id;
            if($scope.target.vulnerability !== new_id) {
                $scope.target.vulnerability = new_id;
                $scope.vulnerabilityNotDeterminded = false;
                $scope.slidersEnabled = false;
                ProjectService.save().then(function(p) {$scope.slidersEnabled = true;});
            }
        };
        $scope.$watch('target.$vulnerability',function(v) {
            // on the watch only change the vulnerability if it has already
            // been determined (user has to have clicked the "Determine Vulnerability" button first).
            if(typeof($scope.target.vulnerability) !== 'undefined') {
                $scope.initVulnerability();
            }
        });
    }
  };
}])
// ensures jsapi is loaded once and only once
.service('JsapiLoader',['$q','$window','$timeout',function($q,$window,$timeout){
    var deferredLoad = $q.defer(),
        service = {
            load: function() {
                return deferredLoad.promise;
            }
        };
    function checkLoadAndResolve() {
        niacs.info('checkLoadAndResolve');
        if($window.google && $window.google.load) {
            niacs.info('google.load now available.');
            deferredLoad.resolve();
        } else {
            $timeout(checkLoadAndResolve,250);
        }
    }
    (function(){
        if(!$window.google || !$window.google.load) {
            // load jsapi
            var s = document.createElement('script');
            s.src = 'https://www.google.com/jsapi';
            document.body.appendChild(s);
        }
        checkLoadAndResolve();
    })();
    return service;
}])
.directive('vulnerabilityPlot',['$window','TaxonomyService','JsapiLoader',function($window,TaxonomyService,JsapiLoader){
  var deferredLoad,
      lineOne = [[30, 0], [100, 70]],
      lineTwo = [[0, 30], [70, 100]],
      lOneSlope = calculateSlope(lineOne),
      lTwoSlope = calculateSlope(lineTwo);
  function drawLines(canvas){
    var context = canvas.getContext('2d'),tmp;
    // fill canvas with moderate color
    context.beginPath();
    context.rect(0,0,canvas.width,canvas.height);
    context.fillStyle = '#c0c5b9';
    context.fill();
    // low region
    context.beginPath();
    context.moveTo(0,0);
    tmp = translate(lineTwo[0],canvas);
    context.lineTo(tmp[0],tmp[1]);
    tmp = translate(lineTwo[1],canvas);
    context.lineTo(tmp[0],tmp[1]);
    context.closePath();
    context.fillStyle = '#dfe7d4';
    context.fill();
    // high region
    context.beginPath();
    context.moveTo(canvas.width,canvas.height);
    tmp = translate(lineOne[0],canvas);
    context.lineTo(tmp[0],tmp[1]);
    tmp = translate(lineOne[1],canvas);
    context.lineTo(tmp[0],tmp[1]);
    context.closePath();
    context.fillStyle = '#73807c';
    context.fill();
    /* wire-frame doesn't have the actual lines
    drawLine(canvas,context,lineOne);
    drawLine(canvas,context,lineTwo);
    */
  }
  function translate(point,canvas) {
    return [
      ((canvas.width/100)*point[0]),
      (canvas.height-((canvas.height/100)*point[1]))
    ];
  }
  function drawLine(canvas,context,line) {
      var start = line[0],
          end = line[1],
          s = translate(start,canvas),
          e = translate(end,canvas);
      context.lineWidth = 1;
      niacs.debug('line('+start[0]+','+start[1]+')-('+end[0]+','+end[1]+')');
      niacs.debug('line_translated('+s[0]+','+s[1]+')-('+e[0]+','+e[1]+')');
      context.beginPath();
      context.moveTo(s[0],s[1]);
      context.lineTo(e[0],e[1]);
      context.stroke();
  }
  /**
   * Calculates the slope of the line passed to it.
   * @param {number} l The line whose slope is to be calculated
   * Format of param l: l[point#][x=0, y=1]. So, l[1][0] = the x-value of the second point of the line
   * @return {number} slope The calculated value of the slope
   */
  function calculateSlope(l) {
    var yOne = l[0][1],
        xOne = l[0][0],
        yTwo = l[1][1],
        xTwo = l[1][0];
    return ((yTwo - yOne) / (xTwo - xOne));
  }
  return {
      restrict: 'E',
      templateUrl: 'partials/directives/vulnerability-plot.html',
      scope: {
        target: '='
      },
      controller: function ($scope) {
        TaxonomyService.get('niacs_vulnerability',function(data){
          $scope.vocab_vulnerability = data;
        });
        // the customer wants points altered...
        function adjustPoint(p) {
          if(typeof(p) === 'string') {
            p = parseInt(p);
          }
          var from = [0,25,50,75,100],
              to = [10,30,50,70,90];
          return to[from.indexOf(p)];
        }
        function getData() {
          var pi = $scope.target.potential_impacts||$scope.target.$potential_impacts,
              ac = $scope.target.adaptive_capacity||$scope.target.$adaptive_capacity;
          // checking null explicitly since zero will evaluate to false and we don't want to
          // over-ride it with 50
          if(pi === null) { pi = 50; }
          if(ac === null) { ac = 50; }
          return new google.visualization.arrayToDataTable(
          [
            ['Potential Impacts', 'Adaptive Capacity'],
            [adjustPoint(pi), adjustPoint(ac)]
          ]);
        }
        function doDraw() {
          $scope.chart.draw(getData(),$scope.options);
        }
        function drawChart() {
          var idEsc = angular.isString($scope.target.id) ? $scope.target.id.replace(/\./g,'\\.') : $scope.target.id,
              plotId = 'vulnerability_plot_'+idEsc,
              plot = $('#'+plotId),plot_w,plot_h;
          if(!plot.length) {
              return;
          }
          plot_w = plot.css('width').replace(/[^-\d\.]/g, '');
          plot_h = plot.css('height').replace(/[^-\d\.]/g, '');
          $scope.options = {
            width: plot_w, height: plot_h,
            legend: 'none',enableInteractivity: false,
            hAxis: {
              title: 'Potential Impacts',
              titleTextStyle: {bold: true,italic: false},
              minValue: 0, maxValue: 100,
              ticks: [{v:0, f:'Very supportive'}, {v:100, f:'Very disruptive'}],
              textStyle: { italic: true }
            },
            vAxis: {
              title: 'Adaptive Capacity',
              titleTextStyle: {bold: true,italic: false},
              minValue: 0,maxValue: 100,
              ticks: [{v:0, f:'Low'}, {v:100, f:'High'}]
            },
            series: {
              0: { pointShape: 'circle', pointSize: 25 },
            },
            colors: ['#d78a2e'],
            chartArea: {
              backgroundColor: {
                fill: 'transparent', // can't seem to css style this.
              }
            },
            backgroundColor: { fill: 'transparent' }
          };
          niacs.info('target',$scope.target);
          $scope.chart = new google.visualization.LineChart(document.getElementById(plotId));
          doDraw();
          if(!$scope.offsets) {
              // find rect and get x/y width/height off of it.
              var rect = plot.find('rect').first(),
                  rectPos = rect.offset(),
                  bg = $('#vulnerability_plot_bg_'+idEsc);
              $scope.offsets = {
                x: parseInt(rect.attr('x')),
                y: parseInt(rect.attr('y')),
                w: parseInt(rect.attr('width')),
                h: parseInt(rect.attr('height'))
              };
              // dynamically position the background relative to the plot
              bg.css({
                'position': 'relative',
                'top': '-'+($scope.offsets.h+((plot_h-$scope.offsets.h)/2))+"px",
                'left': (((plot_w-$scope.offsets.w)/2)+1)+"px"
              });
              bg.attr('width',$scope.offsets.w-1);
              bg.attr('height',$scope.offsets.h-1);
              // draw the regions
              drawLines(bg[0]);
          }
          // if things change re-draw
          $scope.$watch('target.potential_impacts',doDraw);
          $scope.$watch('target.adaptive_capacity',doDraw);
          doDraw();
        }
        function initJsapi() {
          $window.google.load("visualization", "1.1", {callback:function(){
              $scope.$apply(function(){
                  drawChart();
              });
          },packages:["corechart"]});
        }
        $scope.$watch('target',function() {
          if($scope.target) {
              JsapiLoader.load().then(initJsapi);
          }
        });
      }
  };
}])
.directive('niacsVulnerabilityInfo',['TaxonomyService',function(TaxonomyService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/vulnerability-info.html',
    scope: {
      target: '='
    },
    link: function($scope,$element,$attrs) {
      $scope.listStyle = $attrs.listStyle||'list-unstyled';
      if($attrs.addListClasses) {
        $scope.listStyle += ' '+$attrs.addListClasses;
      }
      TaxonomyService.get('niacs_vulnerability',function(data){
        $scope.vocab_vulnerability = data;
      });
    }
  };
}])
.directive('niacsProjectDetails',['TaxonomyService','ProjectService',function(TaxonomyService,ProjectService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/project-details.html',
    scope: {
      project: '='
    },
    link: function($scope,$element,$attr) {
      TaxonomyService.get('state',function(data){
        $scope.vocab_state = data;
      });
      TaxonomyService.get('niacs_project_ownership',function(data){
        $scope.vocab_ownership = data;
      });
      $scope.$watch('project',function(){
        if($attr.editable && $scope.project && $scope.project.meta && $scope.project.meta.noNag) {
          $scope.resetNoNag = function() {
              delete $scope.project.meta.noNag;
              if(niacs.isEmptyObject($scope.project.meta)) {
                delete $scope.project.meta; // drupal turns empty objects into arrays so this is easiest.
              }
              ProjectService.save($scope.project);
              $scope.resetNoNag = null; // remove function...
          };
        }
      });
    }
  };
}])
.directive('niacsNavigation',['$location','$routeParams','MenuService','ProjectService',function($location,$routeParams,MenuService,ProjectService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/navigation.html',
    link: function($scope,$element,$attr) {
      MenuService.getFlatMenu($routeParams,'NiacsNavigation').then(function(menuItems){
          menuItems = menuItems.filter(function(item) { return !!item.item; });
          $scope.current = null;
          $scope.next = null;
          $scope.previous = null;
          $scope.go = function(item) {
            if(item) {
                ProjectService.afterSave(function(){
                    $location.url(item.toString());
                });
            }
          };
          function pathChange() {
              $scope.current = null;
              $scope.next = null;
              $scope.previous = null;
              for(var i = 0; i < menuItems.length; i++) {
                if(MenuService.isMenuItemActive(menuItems[i],$location)) {
                  $scope.current = menuItems[i];
                  $scope.previous = i > 0 ? menuItems[i-1] : undefined;
                  $scope.next = i < menuItems.length ? menuItems[i+1] : undefined;
                  break;
                }
              }
          }
          $scope.$on('$locationChangeSuccess', pathChange);
          pathChange();
      });
    }
  };
}])
.directive('fontAwesomeAction',function(){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/font-awesome-action.html',
    transclude: true,
    scope: {
      action: '&',
      icon: '@',
      title: '@',
      size: '@',
      faClass: '@',
      titleLeft: '@',
      addClasses: '@',
      iconTooltip: '@',
      iconTooltipPlacement: '@',
      faPrefix: '@'
    }
  };
})
.directive('niacsTitlePanel',['$sce','$parse','ShowHideService','CustomTextService',function($sce,$parse,ShowHideService,CustomTextService){
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'partials/directives/title-panel.html',
    scope: {
      uniqueId: '@',
      titlePrefix: '@panelTitlePrefix',
      title: '@panelTitle',
      panelBannerClasses: '@',
      panelBannerStatus: '@',
      banner: '@panelBanner',
      bold: '@',
      addClasses: '@',
      addHeadingClasses: '@',
      addBodyClasses: '@',
      type: '@',
      //id: '@',
      icons: '=',
      icon: '@',
      iconSize: '@',
      iconTitle: '@',
      iconTooltip: '@',
      iconAddClasses: '@',
      iconAction: '&',
      noShowHide: '@',
      initialState: '@',
      xtraButton: '@',
      xtraButtonAction: '&',
      dockable: '@',
      infoPanel: '@', // this name isn't great but can't think of a better one at the moment...  infoIconKey in a panel rather than tooltip.
      //infoIconKey: '@'
      showAccordionNext: '@'
    },
    link: function($scope, $element, $attr){
      $scope.id = $attr.id;
      $scope.isDockable = $scope.dockable||(typeof($scope.dockable) === 'undefined' && ($scope.type === 'instruction' || ($scope.type && $scope.type.indexOf('dockable') != -1)));
      function checkState() {
        if($scope.showHide && typeof($scope.showHide.initial) == 'undefined') {
          $scope.showHide.initial = $scope.initialState;
          if($scope.initialState == 'closed') {
            $scope.showHide.show = false;
          } else if ( $scope.initialState == 'open') {
            $scope.showHide.show = true;
          }
        }
      }
      $scope.doAction = function(action) {
        if(action){
          var result = action();
          // if the action returns a promise let it re-evaluate the current panel state
          if(result && result.then && typeof(result.then) == 'function') {
            result.then(function(){
              delete $scope.showHide.initial;
              checkState();
            });
          }
        }
      };
      $scope.cssType = $scope.type ? $scope.type : 'l1';
      $scope.$watch('initialState',checkState);
      $scope.$watch('showHide',checkState);
      if($scope.isDockable) {
        $scope.$watch('showHide.docked',function(){
            if($scope.uniqueId && $scope.showHide) {
              if($scope.showHide.docked) {
                $scope.showHide.show = true;
              }
              ShowHideService.dockedChange($scope.uniqueId);
            }
        });
      }
      if($attr.accordionMember) {
        $scope.accordionMember = true;
      }
      if($attr.accordionMember || niacs.DEBUG) {
          $scope.$watch('showAccordionNext',function(show) {
             $scope.nextAccordion = show && (show === true || show === 'true') ?  ShowHideService.nextAccordion : undefined;
          });
        $scope.$watch('showHide.show',function(){
          if($scope.uniqueId && $scope.showHide) {
            if($attr.accordionMember) {
              // inform show-hide service of a state change, panel is part of an accordion
              ShowHideService.accordionChange($scope.uniqueId);
            }
            if(niacs.DEBUG) {
              niacs.debug($scope.showHide.show?"show":"hide",$scope.uniqueId);
            }
          }
        });
      }

      $scope.$watch('title',function(o,n){
        if(typeof($scope.title) == 'string') {
          //niacs.info('title',$scope.title);
          if(!$scope.uniqueId) {
            $scope.uniqueId = $scope.title;
          }
        }
        $scope.$title = $sce.trustAsHtml($scope.title);
      });
      $scope.$watch('titlePrefix',function(){
        if(typeof($scope.titlePrefix) == 'string') {
          $scope.$titlePrefix = $sce.trustAsHtml($scope.titlePrefix);
        }
      });
      $scope.$watch('banner',function(){
        if(typeof($scope.banner) == 'string') {
          $scope.$banner = $sce.trustAsHtml($scope.banner);
        }
      });
      $scope.$watch('infoIconKey',function(key) {
          $scope.haveInfoText = false;
          if(key) {
            CustomTextService.object(key).then(function(o){
                $scope.haveInfoText = !!o;
            });
          }
      });
      $scope.$watch('uniqueId',function(){
        if($scope.uniqueId) {
          if(!$scope.id) {
            $scope.id = $scope.uniqueId;
          }
          // need to unconditionally do this since uniqueId might be built from server side data
          // and we can't tell when the result is 'complete'.  this means there will likely end up
          // being a several small 'dangling' objects in the cache with no one ever coming back for them.
          $scope.showHide = ShowHideService.get($scope.uniqueId,$attr.accordionMember);
          if(!$attr.infoIconKey && !$scope.uniqueId.match(/ /)) {
            // if there is no 'coded' info icon tooltip generate a key based
            // on the uniqueId
            var key = $scope.uniqueId;
            while(niacs.endsWithId(key)) {
              key = key.substring(0,key.lastIndexOf('.'));
            }
            $scope.infoIconKey = "TOOLTIP_"+key.replace(/\./g,'_').toUpperCase();
            niacs.debug("Dynamically generated tooltip key for '"+$scope.uniqueId+"' is '" + $scope.infoIconKey + "'");
          } else if ($attr.infoIconKey) {
            $scope.infoIconKey = $attr.infoIconKey;
            niacs.debug("Explicit tooltip key for '"+$scope.uniqueId+"' is '" + $scope.infoIconKey + "'");
          }
        }
      });
    }
  };
}])
.directive('niacsObjectiveEvaluate',['AutoSaveService','TaxonomyService',function(AutoSaveService,TaxonomyService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/objective-evaluate.html',
    scope: {
      context: '=',
      goal: '=',
      saveObjectiveCallback: '=',
      saveStatementCallback: '=',
      removeStatementCallback: '='
    },
    link: function($scope,$element) {
      TaxonomyService.get('niacs_feasibility',function(data){
          $scope.vocab_feasibility = data;
      });
      $scope.isSaving = AutoSaveService.isSaving;
      $scope.$goal = $scope.goal;
      angular.forEach($scope.$goal.objectives,function(objective){
        // the is array check is unfortunate but if you save an empty object to the
        // PHP backend it will render it back to you as [] rather than {}
        if(!objective.evaluate || (angular.isArray(objective.evaluate) && objective.evaluate.length === 0)){
          objective.evaluate={};
        }
        AutoSaveService.setup(objective,function(){
          $scope.saveObjectiveCallback(null,$scope.$goal,objective);
        });
      });
    }
  };
}])
.directive('niacsCisInfo',[function(){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/climate-impact-statement-info.html',
    scope: {
      statement: '='
    },
    link: function($scope,$element,$attrs) {
      $scope.noEvidence = typeof($attrs.noEvidence) !== 'undefined';
      $scope.listStyle = $attrs.listStyle||'list-inline pipe';//'list-unstyled';
    }
  };
}])
.directive('niacsRecapClimateImpacts',['$filter',function($filter){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/recap-climate-impacts.html',
    scope: {
      context: '=',
      statements: '=',
      panelTitle: '@',
      infoIconKey: '@',
      panelType: '@',
      dockable: '@',
      initialState: '@',
    },
    link: function($scope,$element,$attrs) {
        $scope.$watch('statements',function(statements){
            angular.forEach(statements,function(statement){
                //Evidence: {{statement.$evidence}} | Agreement: {{statement.$agreement}}
                statement.$popoverTitle = undefined;
                if(statement.$evidence) {
                    statement.$popoverTitle = 'Evidence: '+statement.$evidence;
                }
                if(statement.$agreement) {
                    if(statement.$popoverTitle) {
                        statement.$popoverTitle += ' | Agreement: '+statement.$agreement;
                    } else {
                        statement.$popoverTitle = 'Agreement: '+statement.$agreement;
                    }

                }

            });
        });
    }
  };
}])
.controller('InfoDialogCtrl',['$scope','$uibModalInstance','theInfo',function($scope,$uibModalInstance,theInfo){
    $scope.theInfo = theInfo;
    $scope.dismiss = $uibModalInstance.dismiss;
}])
.directive('niacsClimateImpacts',['$filter','$uibModal','AutoSaveService','ProjectService',function($filter,$uibModal,AutoSaveService,ProjectService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/climate-impacts.html',
    scope: {
      project: '=',
      unit: '=',
      potentials: '=',
      addCallback: '=',
      removeCallback: '=',
      saveCallback: '='
    },
    link: function($scope,$element) {
      $scope.isSaving = AutoSaveService.isSaving;
      $scope.hasEvidence = function(statement) {
        return statement &&
               (((statement.$resources && statement.$resources.length > 0) || (statement.resources && statement.resources.length > 0)) ||
                ((statement.external_link && statement.external_link.length > 0) || (statement.$external_link && statement.$external_link.length > 0)) ||
                ((statement.local_link && statement.local_link.length > 0) || (statement.$local_link && statement.$local_link.length > 0)));
      };
      $scope.unitType = function() {
        if($scope.unit) {
          return niacs.isPredefined($scope.unit) ? "PreDef_Unit" : "Custom_Unit";
        }
        return "Project";
      };
      $scope.displayPredefined = function() {
        return !$scope.unit || angular.isNumber($scope.unit.id);
      };
      $scope.showEvidence = function(statement) {
        $uibModal.open({
            templateUrl: 'partials/dialogs/impact-evidence.html',
            controller: 'InfoDialogCtrl',
            windowClass: 'niacs-impact-evidence-dialog',
            size: 'lg',
            resolve: {
                theInfo: function() { return statement; }
            }
        });
      };
      $scope.removeCustom = function(statement,holder) {
        niacs.info('removeCustom.holder',holder);
        niacs.info('removeCustom.statement',statement);
        $scope.removeCallback(statement,holder);
      };
      $scope.editCustom = function(statement) {
        niacs.info("editCustom.statement",statement);
        var statementCopy = angular.copy(statement);
        var modal = $uibModal.open({
          templateUrl: 'partials/dialogs/add-edit-custom-cis.html',
          controller: 'AddEditCisCtrl',
          windowClass: 'niacs-custom-cis-dialog',
          size: 'lg',
          keyboard: false,
          backdrop: 'static',
          resolve:{
            unit: function() { return $scope.unit; },
            theStatement: function() { return statementCopy; }
          }
        });
        modal.result.then(function(edited){
          for(var key in edited) {
            statement[key] = edited[key];
          }
          $scope.saveCallback(statement);
        },function(){});
      };
      $scope.addCustom = function(holder) {
        niacs.info('addCustom',holder);
        var modal = $uibModal.open({
          templateUrl: 'partials/dialogs/add-edit-custom-cis.html',
          controller: 'AddEditCisCtrl',
          windowClass: 'niacs-custom-cis-dialog',
          keyboard: false,
          backdrop: 'static',
          resolve:{
            unit: function() { return $scope.unit; },
            theStatement: function() { return {}; }
          }
        });
        modal.result.then(function(newStatement){
          $scope.addCallback(newStatement,$scope.unit||$scope.project);
        },function(){});
      };
      function setup() {
        if($scope.unit) {
          $scope.statements = $scope.unit.cistatements;
        } else if ($scope.project) {
          $scope.statements = $scope.project.cistatements;
        }
        if($scope.statements) {
          angular.forEach($scope.statements,function(statement) {
            AutoSaveService.setup(statement,function(){
              $scope.saveCallback(statement);
            });
            statement.$autosave = (function(self,superFunc){
                return function(){
                    // if the user cleared out the comments then delete them
                    if(!self.comments) {
                        delete self.comments;
                    }
                    superFunc.apply(self,arguments);
                };
            })(statement,statement.$autosave);
          });
        }
      }
      $scope.startComments = function(statement) {
          ProjectService.afterSave(function(){
              // this code is overly complex because of what happens if a user
              // de-focuses a comment and clicks the "comment" icon on another cis
              // when that happens the underlying object reference goes away
              // and so we must re-find the cis in question starting from the project
              // and put the empty comment there or the text area flashes on the screen
              // feels like a bit of a hack.
              var context;
              if($scope.unit) {
                  context = $scope.project.units.reduce(function(found,unit){
                      return (found||($scope.unit.id === unit.id ? unit : undefined));
                  },undefined);
              }
              if(!context) {
                  context = $scope.project;
              }
              if(context ) {
                  (context.cistatements||[]).forEach(function(cis){
                     if(cis.id === statement.id) {
                         cis.comments = '';
                     }
                  });
              }
          });
      };

      $scope.$watch('project',setup);
      $scope.$watch('project.cistatements',setup);
      $scope.$watch('unit',setup);
      $scope.$watch('unit.cistatements',setup);
    }
  };
}])
.directive('niacsStatementForm',['$filter','$log','AutoSaveService','ProjectService','CustomTextService',
  function($filter,$log,AutoSaveService,ProjectService,CustomTextService){
    function initObjective($scope) {
      $scope.statements = [];
      if($scope.type == 'challenge') {
        if($scope.objective && $scope.objective.evaluate && $scope.objective.evaluate.challenges) {
          $scope.statements = $scope.statements.concat($scope.objective.evaluate.challenges);
        }
      } else if ($scope.type == 'opportunity') {
        if($scope.objective && $scope.objective.evaluate && $scope.objective.evaluate.opportunities) {
          $scope.statements = $scope.statements.concat($scope.objective.evaluate.opportunities);
        }
      }
      angular.forEach($scope.statements,function(statement){
        AutoSaveService.setup(statement,function(){
          $scope.saveCallback($scope.objective,statement);
        });
      });
      if($scope.statements.length === 0) {
        addPlaceholder($scope);
      }
    }
    function addPlaceholder($scope) {
          var nStatement = {$new: true, type: $scope.type};
          AutoSaveService.setup(nStatement,function(){
            $scope.saveCallback($scope.objective,nStatement);
          });
          $scope.statements.push(nStatement);
    }
    return {
      restrict: 'E',
      templateUrl: 'partials/directives/statement-form.html',
      scope: {
        addLabel: '@',
        objective: '=',
        saveCallback: '=',
        removeCallback: '=',
        type: '@',
      },
      link: function($scope,$element) {
        $scope.isSaving = AutoSaveService.isSaving;
        $scope.placeHolderKey = $scope.type.toUpperCase()+"_PLACEHOLDER";
        // this is obscure and odd (perhaps a kludge) but it allows
        // the "add <statement>" button to remain enabled during save
        // in this way to disjoint directives can "communicate", i.e.
        // the previous objective where the add button is clicked (during save)
        // can set a transient int on the objective that indicates that the new
        // directive instance should add a placeholder statement, this makes the
        // add button single use without an interim save but this is ok since adding
        // multiple empty placeholders makes no sense.
        $scope.$watch('objective.$add_'+$scope.type,function() {
          if($scope.objective && typeof($scope.objective['$add_'+$scope.type]) != 'undefined') {
            addPlaceholder($scope);
          }
        });
        $scope.addPlaceholder = function() {
          var type = $scope.type,
              $stmnts = $scope.objective.$statements;
          ProjectService.afterSave(function(p){
            // need to search for the objective...
            var ctxs = p.units ? [p].concat(p.units) : [p],
                obj = null,i,j,k;
            for(i = 0; i < ctxs.length; i++) {
              for(j = 0; ctxs[i].goals && j < ctxs[i].goals.length; j++) {
                for(k = 0; ctxs[i].goals[j].objectives && k < ctxs[i].goals[j].objectives.length; k++) {
                  if(ctxs[i].goals[j].objectives[k].id === $scope.objective.id) {
                    obj = ctxs[i].goals[j].objectives[k];
                  }
                }
                if(obj) { break; }
              }
              if(obj) { break; }
            }
            if(!obj) {
              $log.error("Unable to find objective ",$scope.objective);
            } else {
              obj['$add_'+type] = 1;
            }
          });
        };
        initObjective($scope);
      }
    };
}])
.directive('pwGoal',['$log','AutoSaveService','ProjectService','CacheService','DialogService',
  function($log,AutoSaveService,ProjectService,CacheService,DialogService) {
    var VIS_CACHE_PFX="pwg_unitvis_";
    function setup($scope) {
      $scope.$goal = $scope.goal ? $scope.goal : // directive for existing goal
                     {$new: true,id: niacs.guid()}; // new empty, detached, goal.
      initGoal($scope);
    }
    function initGoal($scope) {
      AutoSaveService.setup($scope.$goal,function() {
        save($scope);
      });
    }
    function save($scope) {
        niacs.info("saveGoalObjective.goal",$scope.$goal);
        niacs.info("saveGoalObjective.context",$scope.context);
        if($scope.$goal.$new) {
          if(!$scope.context.goals) {
            $scope.context.goals = [];
          }
          $scope.context.goals.push($scope.$goal);
        }
        ProjectService.save().then(function(){setup($scope);});
    }
    return {
      restrict: 'E',
      templateUrl: 'partials/directives/pw-goals.html',
      scope: {
        context: '=',
        goal: '=',
        index: '@'
      },
      link: function($scope,$element) {
        $scope.isSaving = AutoSaveService.isSaving;
        function initApplicability() {
          if($scope.context && $scope.goal) {
            var applicableCnt = 0;
            angular.forEach($scope.context.units,function(unit){
              niacs.info("initApplicability",unit);
              if(!unit.$applicableGoal) {
                unit.$applicableGoal = {};
              }
              // search this unit to see if this goal is listed there..
              if ( (unit.$applicableGoal[$scope.goal.id] = niacs.findById(unit.goals,$scope.goal.id) !== null) ) {
                applicableCnt++;
              }
            });
            $scope.goal.$applicableCnt = applicableCnt;
            $scope.goal.$unitVisibility = CacheService.get(VIS_CACHE_PFX+$scope.goal.id);
            if($scope.goal.$unitVisibility === null || applicableCnt === 0) {
              $scope.goal.$unitVisibility = applicableCnt === 0;

            }
          }
        }
        $scope.$watch('context',initApplicability);
        $scope.$watch('goal',initApplicability);
        $scope.$watch('goal.$unitVisibility',function() {
          if($scope.goal && typeof($scope.goal.$unitVisibility) !== 'undefined') {
            CacheService.put(VIS_CACHE_PFX+$scope.goal.id,$scope.goal.$unitVisibility,-1);
          }
        });

        // helper functions for safe delete dialogs.
        function getReferencingUnits() {
          var refs = [];
          angular.forEach($scope.context.units,function(unit){
            if(unit.$applicableGoal[$scope.goal.id]) {
              refs.push(unit);
            }
          });
          return refs;
        }
        function getReferencingObjectives(units) {
          var refs = [];
          angular.forEach(units,function(unit){
            var goal = niacs.findById(unit.goals,$scope.goal.id);
            if(!goal) {
              $log.error("Unable to find goal reference in unit.");
            } else if(goal.objectives && goal.objectives.length) {
              refs = refs.concat(goal.objectives);
            }
          });
          return refs;
        }

        $scope.changeApplicability = function(unit) {
          //unit.$applicableGoal[goal.id]
          niacs.info("changeApplicability",unit,unit.$applicableGoal[$scope.goal.id]);
          if(unit.$applicableGoal[$scope.goal.id]) {
            if(!unit.goals) {
              unit.goals = [];
            }
            unit.goals.push({id: $scope.goal.id});
            ProjectService.save().then(initApplicability);
          } else {
            // being marked as not applicable test to see if it's safe to delete the reference
            var goal = niacs.findById(unit.goals,$scope.goal.id);
            if(!goal) {
              $log.error("Unable to find goal reference",$scope.goal,unit);
              return;
            }
            if(goal.objectives && goal.objectives.length) {
              unit.$applicableGoal[$scope.goal.id] = true; // mark as applicable so it remains visible under the dialog.
              var dialogContents = {
                message: 'Are you sure you want to remove this goal from '+(unit.label||unit.$label)+'?',
                warning: 'This cannot be undone.',
                okText: 'Yes, remove this goal',
                cancelText: 'No, keep this goal',
                conditions: [
                  goal.objectives.length+' objectives have been defined for this goal.',
                ]
              };
              niacs.addSafeDeleteCounts(goal.objectives,dialogContents);
              DialogService.safe(dialogContents).then(function() {
                niacs.info('user confirmed deletion of goal reference from unit.',$scope.goal,unit);
                if (!niacs.removeById(unit.goals,$scope.goal.id)) {
                  $log.error("Unable to remove goal from unit",$scope.goal,unit);
                }
                ProjectService.save().then(initApplicability);
              });
            } else {
              if (!niacs.removeById(unit.goals,$scope.goal.id)) {
                $log.error("Unable to remove goal from unit",$scope.goal,unit);
              }
              ProjectService.save().then(initApplicability);
            }
          }
        };
        $scope.removeGoal = function() {
          niacs.info("removeGoal.goal",$scope.$goal);
          niacs.info("removeGoal.context",$scope.context);
          if($scope.$goal.new) {
            return;
          }
          if($scope.goal.$applicableCnt > 0) {
            // this goal is referenced elsewhere gather info about what it references
            // and force the user to agree to the deletion.
            var dialogContents = {
              message: 'Are you sure you want to remove this goal?',
              warning: 'This cannot be undone.',
              okText: 'Yes, remove this goal',
              cancelText: 'No, keep this goal',
              conditions: [
                $scope.goal.$applicableCnt+' Management Topics reference this goal.',
              ]
            },
            units = getReferencingUnits(),
            objectives = getReferencingObjectives(units);
            if(objectives.length) {
              dialogContents.conditions.push(objectives.length+ " objectives have been defined.");
              niacs.addSafeDeleteCounts(objectives,dialogContents);
            }
            DialogService.safe(dialogContents).then(function() {
              niacs.info('user confirmed deletion of goal with references.',$scope.goal);
              angular.forEach(units,function(unit){
                if(!niacs.removeById(unit.goals,$scope.goal.id)) {
                  $log.error("unable to find unit goal to remove", $scope.$goal, unit);
                }
              });
              if(!niacs.removeById($scope.context.goals,$scope.$goal.id)) {
                $log.error('unable to find goal to remove',$scope.goal);
              }
              ProjectService.save();
            });
          } else {
            if(!niacs.removeById($scope.context.goals,$scope.$goal.id)) {
                $log.error("unable to find goal to remove", $scope.$goal);
            }
            ProjectService.save();
          }
        };
        // get the ball rolling
        setup($scope);
      }
    };
}])
.directive('niacsGoalForm', ['$log','AutoSaveService','ProjectService','RedirectionService','DialogService',
  // goals and objectives flagged with $new aren't bound into the project yet
  function($log,AutoSaveService,ProjectService,RedirectionService,DialogService) {
    function setup($scope) {
      $scope.$goal = $scope.goal ? $scope.goal : // directive for existing goal
                     {$new: true,id: niacs.guid(),objectives: [{id: niacs.guid()}]}; // new empty, detached, goal.
      if(!$scope.$goal.objectives) {
        $scope.$goal.objectives = [];
      }
      initGoal($scope);
    }
    function initGoal($scope) {
      AutoSaveService.setup($scope.$goal,function() {
        save($scope);
      });
      $scope.objectives = $scope.$goal.objectives;
      angular.forEach($scope.objectives,function(objective){
        AutoSaveService.setup(objective,function(){
          save($scope);
        });
      });
    }
    // strip out "empty" objectives (end-case).
    function presave(goal) {
      // don't do for 1 objective (i.e. leave single empty objective)
      if(goal && goal.objectives && goal.objectives.length > 1) {
        var emptyIdx = -1,i;
        do {
          emptyIdx = -1;
          for(i = 0; i < goal.objectives.length; i++) {
            if(!goal.objectives[i].description && !goal.objectives[i].timeframe) {
              emptyIdx = i;
              break;
            }
          }
          if(emptyIdx != -1) {
            goal.objectives.splice(emptyIdx,1);
          }
        } while(emptyIdx != -1);

      }
    }
    function save($scope) {
        niacs.info("saveGoalObjective.goal",$scope.$goal);
        niacs.info("saveGoalObjective.context",$scope.context);
        if($scope.$goal.$new) {
          if(!$scope.context.goals) {
            $scope.context.goals = [];
          }
          $scope.context.goals.push($scope.$goal);
        }
        presave($scope.$goal);
        ProjectService.save().then(function(){setup($scope);});
    }
    return {
      restrict: 'E',
      templateUrl: 'partials/directives/goal-objective-form.html',
      scope: {
        context: '=',
        goal: '=',
        index: '@'
      },
      link: function($scope,$element) {
        ProjectService.get(null,null,function(p) { $scope.project = p; });
        $scope.isSaving = AutoSaveService.isSaving;
        $scope.visit = RedirectionService.visit;
        $scope.removeGoal = function() {
          niacs.info("removeGoal.goal",$scope.$goal);
          niacs.info("removeGoal.context",$scope.context);
          function doRemove() {
              if(!niacs.removeById($scope.context.goals,$scope.$goal.id)) {
                  $log.error("unable to find goal to remove", $scope.$goal);
                  return;
              }
              ProjectService.save();
          }
          if(!$scope.$goal.$new) {
            var goal = $scope.goal,unit = $scope.context;
            // nag if there are objectives OR the goal has a description.
            // if the description is empty OR it's a shared goal (which can simply be re-added)
            // then don't nag the user about this.
            if((goal.objectives && goal.objectives.length) || goal.description) {
              var dialogContents = {
                message: 'Are you sure you want to remove this goal from '+(unit.label||unit.$label)+'?',
                warning: 'This cannot be undone.',
                okText: 'Yes, remove this goal',
                cancelText: 'No, keep this goal',
                conditions: []
              };
              if(goal.objectives && goal.objectives.length) {
                dialogContents.conditions.push(goal.objectives.length+' objectives have been defined for this goal.');
                niacs.addSafeDeleteCounts(goal.objectives,dialogContents);
              }
              DialogService.safe(dialogContents).then(doRemove);
            } else {
              doRemove();
            }
          }
        };
        $scope.removeObjective = function(objective) {
          if(!objective.$new) {
            var dialogContents = {
              message: 'Are you sure you want to remove this objective?',
              warning: 'This cannot be undone.',
              okText: 'Yes, remove this objective',
              cancelText: 'No, keep this objective',
              conditions: []
            };
            if(!niacs.isEmptyObject(objective.evaluate)) {
              dialogContents.conditions.push('Evaluation details have been supplied.');
            }
            if(objective.tactics && objective.tactics.length) {
              dialogContents.conditions.push(objective.tactics.length+' adaptation tactics have been selected.');
            }
            if(objective.monitor && objective.monitor.length > 0) {
              dialogContents.conditions.push(objective.monitor.length + ' monitoring plans have been selected.');
            }
            DialogService.safe(dialogContents).then(function() {
              if(!niacs.removeById($scope.$goal.objectives,objective.id)) {
                  $log.error("unable to find objective to remove",$scope.$goal,objective);
                  return;
              }
              presave($scope.$goal);
              ProjectService.save();
            });
          }
        };
        setup($scope);
        $scope.addObjective = function() {
          // this is less than ideal but to allow "add" buttons to be enabled during a save
          // and have the action work we need to search for the context/goal in question rather
          // than simply modifying them since a save may have pulled the rug our from under us.
          ProjectService.afterSave(function(p){
            var ctxs = p.units ? [p].concat(p.units) : [p],
                ctx = niacs.findById(ctxs,$scope.context.id),
                goal = ctx != null ? niacs.findById(ctx.goals,$scope.goal.id) : null;
            if(goal) {
              goal.objectives.push({$new: true,id:niacs.guid()});
              initGoal($scope);
            }
          });
        };
      }
    };
}])
.directive('tacticDetails',['TaxonomyService','NiacsStrategyService',function(TaxonomyService,NiacsStrategyService){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/tactic-details.html',
    scope: {
      tactic: '=',
      full: '@', // if full=true then must supply project
      project: '='
    },
    link: function($scope,$element) {
        TaxonomyService.get('tactic_practicability',function(data){
          $scope.vocab_tactic_practicability = data;
        });
        NiacsStrategyService.getSourceTree().then(function(tree) {
          $scope.strategyName = function(sid) {
            var strat = tree.getStrategy(sid);
            return strat ? tree.getStrategyLabel(strat,$scope.project) : '';
          };
          $scope.approachName = function(sid,aid) {
            var app = tree.getApproach(sid,aid);
            return app ? app.name : "";
          };
        });
    }
  };
}])
.directive('projectMap',['$timeout',
  function($timeout){
    return {
      restrict: 'E',
      template: '<div class="{{addClasses}}" id="gMap.{{mapSuffix||project.id}}"></div>',
      scope: {
        addClasses: '@',
        mapSuffix: '@',
        project: '=',
        onReady: '&',
        //zoom: '@', $attrs.zoom
      },
      link: function($scope,$element,$attrs) {
        function init() {
          if(!$scope.project) {
            return;
          }
          if(!$scope.map) {
            $scope.mapCanvas = document.getElementById('gMap.'+($scope.mapSuffix||$scope.project.id));
            if($scope.mapCanvas) {
              $scope.map = new google.maps.Map($scope.mapCanvas,{
                zoom: $attrs.zoom||8,
                streetViewControl: false,
                draggable: $attrs.draggable === 'true',
                panControl: $attrs.panControl === 'true',
                zoomControl: $attrs.zoomControl === 'true',
                mapTypeControl: false
              });
            }
          }
          if($scope.map) {
              $scope.marker = new google.maps.Marker({
                  position: new google.maps.LatLng($scope.project.lat, $scope.project.lon),
                  map: $scope.map,
                  title: $scope.project.label,
                  draggable: false,
                  icon: niacs.ModuleUrl+'/img/marker.png'
              });
              $scope.map.setCenter($scope.marker.getPosition());
              if($scope.onReady) {
                google.maps.event.addListenerOnce($scope.map,'tilesloaded',function() {
                    $scope.$apply(function(){
                      $timeout(function(){$scope.onReady();},500);
                    });
                });
              }
          }
        }
        $scope.$watch('project.id',function(){
          $timeout(init,500);
        });
      }
    };
}])
.directive('numberWithCommas',['$q',function($q){
    var N_W_COMMAS_REGEXP = /^\d+(\,?\d\d\d)*$/;
    return {
        require: 'ngModel',
        link: function($scope,$elm,$attrs,$ngModel){
            $ngModel.$asyncValidators.numberWithCommas = function(modelValue,newValue) {
              var def = $q.defer(),
                  v = (modelValue||newValue);
              if(v && (angular.isNumber(v) ||
                       (angular.isString(v) && N_W_COMMAS_REGEXP.test(v)))) {
                def.resolve(true);
              } else if(!v) {
                  def.resolve(true); // optional
              } else {
                def.reject();
              }
              return def.promise;
            };
        }
    };
}])
.directive('niacsProjectContainer',['$routeParams','ProjectService',function($routeParams,ProjectService){
    return {
        restrict: 'C',
        scope: {},
        link: function($scope,$elm) {
            ProjectService.get($routeParams,'NiacsProjectContainer',function(project){
                if(project && project.strategy_sources && project.strategy_sources.length) {
                    $elm.addClass(project.strategy_sources[0].replace(/_/g,'-'));
                }
            });
        }
    };
}])
.directive('autoSaveIndicator',['AutoSaveService',function(AutoSaveService) {
    return {
        restrict: 'C',
        template: '<div ng-show="isSaving()" class="auto-content"><div class="saving">Saving</div><fa-icon icon="spinner" class="fa-1_5x" classes="fa-spin"></fa-icon></div>',
        scope: {},
        link: function($scope) {
            $scope.isSaving = AutoSaveService.isSaving;
        }
    };
}])
.directive('instructionsBackdrop',['$q','$location','$routeParams','MenuService','ProjectService','CourseOfferingService',function($q,$location,$routeParams,MenuService,ProjectService,CourseOfferingService){
    return {
        restrict: 'C',
        scope:{},
        controller: ['$scope','$element',function($scope,$element){
            var instructPanel,
                materialsPanel;
            function getProjectCourse() {
                var def = $q.defer();
                ProjectService.get({id:$location.path().replace(/^.*\//,'')},'instructionPanels',function(project){
                    CourseOfferingService.getForProject(project).then(function(course){
                        project.meta = project.meta||{};
                        project.meta.insts = project.meta.insts||{};
                        if(course && course.materials) {
                            project.meta.cmats = project.meta.cmats||{};
                        }
                        def.resolve([project,course]);
                    });
                });
                return def.promise;
            }
            this.instructions = function(i) { instructPanel = i; };
            this.materials = function(m) { materialsPanel = m; };
            $scope.$on('$locationChangeSuccess',function(){
                var hasTrainingMaterials = false,
                    step = MenuService.getMenuPath($location).getStep();
                $scope.step = materialsPanel.step = instructPanel.step = step;
                getProjectCourse().then(function(results){
                    var project = results[0],
                        course = results[1];
                    $scope.project = materialsPanel.project = instructPanel.project = project;
                    project.meta = project.meta||{};
                    project.meta.insts = project.meta.insts||{};
                    if(course && course.materials && course.materials[step]) {
                        hasTrainingMaterials = true;
                        project.meta.cmats = project.meta.cmats||{};
                        materialsPanel.courseMaterials = course.materials[step];
                        if(typeof(project.meta.cmats[step]) === 'undefined') {
                            project.meta.cmats[step] = false; // open if course materials not seen before
                        }
                    } else if(typeof(project.meta.insts[step]) === 'undefined') {
                        project.meta.insts[step] = niacs.instructions[step] ? false : undefined; // open if instructions exist and not seen before
                    }
                    $('body')[hasTrainingMaterials ? 'addClass' : 'removeClass']('has-training-materials');
                });
            });
            function backdropState() {
                var open = false,
                    project = $scope.project,
                    meta = project ? project.meta : undefined,
                    step = $scope.step;
                if(project && step && meta) {
                    open = (meta.insts && typeof(meta.insts[step]) !== 'undefined' && !meta.insts[step]) ||
                           (meta.cmats && typeof(meta.cmats[step]) !== 'undefined' && !meta.cmats[step]);
                }
                $element[open ? 'addClass' : 'removeClass']('open');
            }
            $scope.$watch('project.meta.cmats[step]',function(collapsed) {
                var meta = $scope.project ? $scope.project.meta : undefined,
                    step = $scope.step;
                if(typeof(collapsed) !== 'undefined' && collapsed && meta &&
                   typeof(meta.insts[step]) === 'undefined') {
                       // the user closed the course materials panel and have never seen
                       // the instructions panel, open it.
                       meta.insts[step] = false;
                }
                backdropState();
            });
            $scope.$watch('project.meta.insts[step]',function(collapsed){
                var meta = $scope.project ? $scope.project.meta : undefined,
                    step = $scope.step;
                if(typeof(collapsed) !== 'undefined' && !collapsed && meta && meta.cmats &&
                   typeof(meta.cmats[step]) !== 'undefined') {
                    // user opened instructions while existing course materials were possibly opened
                    // make sure course materials are closed.
                    meta.cmats[step] = true;
                }
                backdropState();
            });
        }]
    };
}])
.directive('trainingMaterials',['CourseOfferingService',function(CourseOfferingService){
  return {
    restrict: 'C',
    require: '?^^instructionsBackdrop', // optional on parent
    template: '<div ng-show="courseMaterials">'+
        '<label class="course-materials-title"><fa-icon icon="book"></fa-icon> {{courseMaterials.title}}</label>'+
        '<a class="instructions-toggle" href ng-click="project.meta.cmats[step] = !project.meta.cmats[step];"><fa-icon icon="{{project.meta.cmats[step] ? \'chevron-down\' : \'chevron-up\'}}"></fa-icon></a>'+
        '<div ng-bind-html="courseMaterials.$content"></div>'+
    '</div>',
    link: function($scope,$elm,$attrs,$backdrop) {
        $backdrop.materials($scope);
        $scope.$watch('project.meta.cmats[step]',function(collapsed) {
            if(typeof(collapsed) !== 'undefined') {
                $elm[(collapsed ? 'add' : 'remove')+'Class']('collapsed');
            }
        });
    }
  };
}])
.directive('instructionsBanner',[function(){
    var MENU_TITLES = niacs.flattenMenu().reduce(function(map,item) {
        if(item.item && item.label) {
            map[item.item] = item.label;
        }
        return map;
    },{});
    return {
        restrict: 'C',
        require: '^^instructionsBackdrop', // require on parent
        template: '<div class="auto-save-indicator"></div>'+
            '<label class="instructions-title" ng-if="title && collapsed"><fa-icon icon="youtube" fa-prefix="fab"></fa-icon> {{title}} instructions</label>'+
            '<a ng-show="niacs.instructions[step]" class="instructions-toggle" href ng-click="toggle();"><fa-icon icon="{{collapsed ? \'chevron-down\' : \'chevron-up\'}}"></fa-icon></a>'+
            '<custom-html key="{{niacs.instructions[step]}}"></custom-html>'+
            '<niacs-resources ng-if="niacs.instructions[step] && !project.meta.insts[step]" add-classes="step" context="\'step\'"></niacs-resources>',
        link: function($scope,$elm,$attrs,$backdrop){
            $scope.collapsed = true;
            $backdrop.instructions($scope);
            $scope.$watch('project.meta.insts[step]',function(collapsed) {
                if(typeof(collapsed) !== 'undefined') {
                    $scope.collapsed = collapsed;
                    $elm[(collapsed ? 'add' : 'remove')+'Class']('collapsed');
                }
            });
            $scope.$watch('step',function(step) {
                $scope.title = MENU_TITLES[step];
            });
            $scope.toggle = function() {
                var project = $scope.project,
                    step = $scope.step;
                if(typeof(project.meta.insts[step]) === 'undefined') {
                    project.meta.insts[step] = false;
                } else {
                    project.meta.insts[step] = !project.meta.insts[step];
                }
            };
        }
    };
}])
.directive('staticTrainingMaterials',['CourseOfferingService',function(CourseOfferingService){
  return {
    restrict: 'C',
    template: '<div ng-show="courseMaterials">'+
        '<label class="course-materials-title">{{courseMaterials.title}}</label>'+
        '<div ng-bind-html="courseMaterials.$content"></div>'+
    '</div>',
    scope: {
      courseMaterials: '=materials'
    }
  };
}])
.directive('courseOfferingMaterials',['$log',function($log){
  return {
    restrict: 'E',
    scope: {
      offering: '='
    },
    template: '<div class="static-training-materials" ng-repeat="m in materials" materials="m"></div>',
    link: function($scope) {
      $scope.$watch('offering',function(offering) {
        if(!offering) {
          return;
        }
        // need to order materials based on the menu layout otherwise if
        // just using keys they will show up all jumbled up..
        var materials = [];
        function menu_functor(obj) {
            return function(key) {
                var value = obj[key];
                if(angular.isObject(value)) {
                    Object.keys(value).forEach(menu_functor(value));
                } else if(offering.materials[value]) {
                    materials.push(offering.materials[value]);
                }
            };
        }
        Object.keys(niacs.menu).forEach(menu_functor(niacs.menu));
        // for some a/b steps the NIACS team will cut/paste the course materials
        // eliminate duplicates.  for some reason some text representations mix
        // space and non-breaking space (charcode 160) so focing nbsp to ' '
        // so comparisons work.
        // this is a somewhat low-rent solution to this duplication issue.
        $scope.materials = (function(materials){
            var nbsp = String.fromCharCode(160),
                normalize = function(s) {
                    return s.trim().split('').map(function(c) { return c === nbsp ? ' ' : c; }).join('');
                },
                contents = [],
                $elm = ($||jQuery)('<div />');
            return materials.filter(function(m) {
                var c = normalize($elm.html(m.content).text());
                if(contents.indexOf(c) !== -1) {
                    $log.debug('discarding duplicate course materials for '+m.key+'/'+m.title);
                    return false;
                }
                contents.push(c);
                return true;
            });
        })(materials);
      });
    }
  };
}])
.directive('courseMaterialsRoute',['$routeParams','CourseOffering',function($routeParams,CourseOffering){
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="ng-cloak"><h1>{{offering.title}} :: Course Materials</h1>'+
    '<course-offering-materials offering="offering"></course-offering-materials></div>',
    link: function($scope) {
      CourseOffering.get({id:$routeParams.courseId,offering:$routeParams.offeringId},function(offering){
        $scope.offering = offering;
      });
    }
  };
}])
.directive('workbookMenuToggle',[function(){
    return {
        restrict: 'E',
        template: '<a href class="workbook-menu-toggle" ng-click="toggle()"><fa-icon icon="{{offCanvas ? \'bars\' : \'times\'}}"></fa-icon></a>',
        scope: {},
        link: function($scope,$element) {
            var menu = $('div.workbook-menu'),
                body = $('body');
            $scope.toggle = function() {
                menu.toggleClass('offcanvas');
                body.toggleClass('menu-offcanvas');
                $scope.offCanvas = menu.hasClass('offcanvas');
            };
        }
    };
}])
.directive('toggle',[function(){
    return {
        restrict: 'E',
        replace: true,
        template: '<a href ng-click="onToggle()" class="toggle {{classes}}" ng-class="[onOff]" '+
        'uib-tooltip="{{tooltip}}" tooltip-placement="auto left"><fa-icon icon="toggle-{{onOff}}"></fa-icon></a>',
        scope: {
            on: '@',
            classes: '@',
            onTooltip: '@',
            offTooltip: '@',
            onToggle: '&'
        },
        link: function($scope) {
            $scope.$watch('on',function(value) {
                $scope.onOff = (value && value !== 'false') ? 'on' : 'off';
                $scope.tooltip = $scope.onOff === 'on' ? $scope.onTooltip : $scope.offTooltip;
            });
        }
    };
}]);
